import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import appointmentService from "../../services/appointmentService";
import litigantMenuActions from "../../actions/litigantMenuActions";
import alertActions from "../../actions/alertActions";

const CancelAppointmentModal = () => {
  const menuOptions = useSelector(
    (state) => state.litigantMenu.litigantMenuOptions
  );
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const cancelAppointment = () => {
    appointmentService
      .cancelAppointmentUser({
        userId: "0",
        appointmentId: menuOptions.appointmentId,
      })
      .then(() => {
        dispatch(alertActions.success("Successfully cancelled appointment."));
        dispatch(litigantMenuActions.getLitigantMenuOptions());

        toggle();
      });
  };

  const rescheduleAppointment = () => {
    appointmentService
      .userRescheduleAppointment({
        userId: "0",
        appointmentId: menuOptions.appointmentId,
      })
      .then(() => {
        dispatch(
          alertActions.success(
            "Successfully cancelled appointment. Request for a reschedule sent to staff."
          )
        );
        dispatch(litigantMenuActions.getLitigantMenuOptions());

        toggle();
      });
  };
  return (
    <div className="mt-auto">
      <Button onClick={toggle} color="danger">
        Reschedule/Cancel appointment
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Reschedule/Cancel appointment!
        </ModalHeader>
        <ModalBody>
          <p>
            Clicking <i>cancel</i> below will cancel your appointment. Clicking{" "}
            <i>reschedule</i> will cancel your appointment and notify staff that
            you would like to reschedule.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={cancelAppointment}>
            Cancel Appointment!
          </Button>{" "}
          <Button color="danger" onClick={rescheduleAppointment}>
            Reschedule Appointment!
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CancelAppointmentModal;
